export default __webpack_public_path__ + "static/media/Gallery6.774497ad.webp";